var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11846 16.7578C2.49648 16.7578 2.81781 16.6066 3.19583 16.3892L14.2153 10.0195C14.9997 9.5564 15.2738 9.25397 15.2738 8.75309C15.2738 8.2522 14.9997 7.94978 14.2153 7.49615L3.19583 1.11694C2.81781 0.899573 2.49648 0.757812 2.11846 0.757812C1.41911 0.757812 0.984375 1.28705 0.984375 2.10926V15.3969C0.984375 16.2191 1.41911 16.7578 2.11846 16.7578Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-play.c61bb7a04a1fa3c0f9bf0454be5260cf.svg";